// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-simulacao[data-v-1b34c13f] {\n  padding: 1em;\n}\n", ""]);
// Exports
module.exports = exports;
